import { Icon } from '@/components/icon';
import { MODE_ROAD } from '@/lib/constants';
import { SegmentModeType } from '@/types/api-types';
import { convertModeType } from '@/utils/format';
import { getTransportColor } from '@/utils/helpers/get-transport-color';
import { tv } from '@/utils/styles';

interface Props {
  mode: SegmentModeType;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Returns a styled Mode Icon with colored background
 * @param mode Mode of Vehicle
 * @param size 'sm' | 'md' | 'lg'
 * @returns Component
 */
const ModeIcon = ({ mode, size = 'md' }: Props) => {
  const { base, iconWrapper, icon } = styles({ size });

  return (
    <div className={base()}>
      <span className={iconWrapper()} style={{ backgroundColor: getTransportColor(mode) }}>
        <Icon name={convertModeType(mode)} className={icon()} color={mode !== MODE_ROAD ? 'white' : 'grey.500'} />
      </span>
    </div>
  );
};

const styles = tv({
  slots: {
    base: '',
    iconWrapper: 'grid size-full place-items-center rounded-full',
    icon: 'size-inherit',
  },
  variants: {
    size: {
      lg: {
        base: 'size-8 min-w-8',
        icon: '[&_svg]:size-4',
      },
      md: {
        base: 'size-6 min-w-6',
        icon: '[&_svg]:size-4',
      },
      sm: {
        base: 'size-5 min-w-5',
        icon: '[&_svg]:size-3.5',
      },
    },
  },
});

export { ModeIcon };
